export default __webpack_public_path__ + "static/decorist-3-cc7ac9465186681df60934ab02ef6641.webp";